"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNITS_TYPE_OF_DATE = exports.FACES = exports.QUESTION = exports.DEFAULT_FIVE9_CONFIGURATION = exports.FRAME_STYLES_FIVE9_CHAT = exports.CLASS_FIVE9_BUBBLE = exports.CLASS_INITIALIZE_NEW_CHAT_BUTTON = exports.ID_CARD_LOADING = exports.ID_CARD_THANKS = exports.ID_CARD_CONVERSATION = exports.ID_CARD_SURVEY = exports.ID_SEND_SURVEY_BUTTON = exports.ID_EMBEDDED_FRAME = exports.ID_FIVE9_FRAME_FULL = exports.MESSAGES_TIME_FORMAT = exports.USER_TYPE = exports.LAST_AGENT_MESSAGE_ID = exports.LAST_CLIENT_MESSAGE_ID = exports.COMPANY_DATA = exports.SUCCESS_CLOSED_FIVE9_SURVEY = exports.SURVEY_URL_PROPERTY = exports.FIELDS_FIVE9_PROPERTY = exports.REMOVE_FIVE9_DEFAULT_PROPERTY = exports.SCRIPT_FILE_FIVE9_CHAT = exports.LOAD_TAG_FIVE9_CHAT = exports.ID_SCRIPT_FILE_FIVE9_CHAT = void 0;
exports.ID_SCRIPT_FILE_FIVE9_CHAT = "Five9ChatScript";
exports.LOAD_TAG_FIVE9_CHAT = "data-siigo-five9";
exports.SCRIPT_FILE_FIVE9_CHAT = "https://app.five9.com/consoles/SocialWidget/five9-social-widget.min.js";
exports.REMOVE_FIVE9_DEFAULT_PROPERTY = "remove";
exports.FIELDS_FIVE9_PROPERTY = "fields";
exports.SURVEY_URL_PROPERTY = "survey";
exports.SUCCESS_CLOSED_FIVE9_SURVEY = "successCompletedSurvey";
exports.COMPANY_DATA = (_a = sessionStorage.getItem("CompanyKey")) === null || _a === void 0 ? void 0 : _a.toUpperCase();
exports.LAST_CLIENT_MESSAGE_ID = "last-client-message";
exports.LAST_AGENT_MESSAGE_ID = "last-agent-message";
exports.USER_TYPE = {
    CLIENT: "client",
    AGENT: "agent"
};
exports.MESSAGES_TIME_FORMAT = "hh:mm a";
exports.ID_FIVE9_FRAME_FULL = "five9-frame-full";
exports.ID_EMBEDDED_FRAME = "embedded-frame";
exports.ID_SEND_SURVEY_BUTTON = "send-survey-button";
exports.ID_CARD_SURVEY = "card";
exports.ID_CARD_CONVERSATION = "conversation-card";
exports.ID_CARD_THANKS = "thanks";
exports.ID_CARD_LOADING = "loading";
exports.CLASS_INITIALIZE_NEW_CHAT_BUTTON = "initialize-new-chat-button";
exports.CLASS_FIVE9_BUBBLE = "five9-frame-minimized";
exports.FRAME_STYLES_FIVE9_CHAT = { BOTTOM: "1rem" };
exports.DEFAULT_FIVE9_CONFIGURATION = {
    type: "chat",
    restAPI: "https://app.five9.com",
    rootUrl: "https://app.five9.com/consoles/",
    tenant: "Siigo S.A.",
    fields: {},
    profiles: ["Colombia_Customer_Chat"],
    title: "Siigo S.A.",
    theme: "https://d2gh2oz6jtmsd4.cloudfront.net/assets/chat/five9/siigo.css",
    logo: "https://cdnmicrofrontends.azureedge.net/assets/images/logo_white_five9_header.png",
    lang: "https://d2gh2oz6jtmsd4.cloudfront.net/assets/chat/five9/language.js",
    showProfiles: false,
    useBusinessHours: true,
};
exports.QUESTION = "Puntea nuestra atención :D";
exports.FACES = {
    ANGRY: {
        label: "angry",
        value: 0,
    },
    SAD: {
        label: "sad",
        value: 25,
    },
    NEUTRAL: {
        label: "neutral",
        value: 50,
    },
    GOOD: {
        label: "good",
        value: 75,
    },
    HAPPY: {
        label: "happy",
        value: 100,
    },
};
exports.UNITS_TYPE_OF_DATE = {
    MILLISECONDS: 'milliseconds',
    SECONDS: 'seconds',
    MINUTES: 'minutes',
    HOURS: 'hours',
    DAYS: 'days',
    MONTHS: 'months',
    YEARS: 'years',
    DATES: 'dates'
};
//# sourceMappingURL=constants.js.map